import { ActionButton } from './components/ActionButton';
import { AlertActionItem } from '@/types/alert';
import { usePermissions } from '@/hooks/usePermissions';

interface ActionableItemsProps {
    actions: AlertActionItem[];
}

export function ActionableItems({ actions }: ActionableItemsProps) {
    const { has } = usePermissions();

    const visibleActions = actions.filter(
        (action) => action.permission === undefined || has(action.permission),
    );

    return (
        <div className="flex flex-wrap justify-center gap-3 w-full">
            {visibleActions.map((action) => (
                <ActionButton
                    key={action.title}
                    title={action.title}
                    onClick={action.onClick}
                    shortcut={action.shortcut}
                />
            ))}
        </div>
    );
}
